.sidebar {
	position: absolute;
	display: flex;
	top: 0px;
	left: calc(var(--tla-sidebar-width) * -1);
	height: 100%;
	width: var(--tla-sidebar-width);
	z-index: 100;
	transform: translate(0px, 0px);
	flex-direction: column;
	flex: 0 0 auto;
	padding: 0 0 4px 0;
	background: var(--tla-color-sidebar);
	border-right: 1px solid var(--tl-color-low, rgba(237, 240, 242, 1));
	transition: transform 0.16s ease-in-out;
}

:global(.tl-container[dir='rtl']) .sidebar {
	left: auto;
	right: calc(var(--tla-sidebar-width) * -1);
	border-right: none;
	border-left: 1px solid transparent;
}

.sidebarOverlayMobile {
	all: unset;
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	z-index: 99;
	background-color: var(--tl-color-overlay);
	display: none;
}

@media (min-width: 768px) {
	.sidebar[data-visible='true'] {
		transform: translate(100%, 0px);
		transition: transform 0.22s ease-out;
	}

	:global(.tl-container[dir='rtl']) .sidebar {
		border-right: none;
		border-left: 1px solid var(--tl-color-low);
	}

	:global(.tl-container[dir='rtl']) .sidebar[data-visible='true'] {
		transform: translate(-100%, 0px);
	}
}

@media (max-width: 767px) {
	.sidebar {
		--w: min(320px, max(220px, calc(100vw - 100px)));
		left: calc(var(--w) * -1);
		width: var(--w);
		transition: none;
	}

	.sidebar[data-visiblemobile='true'] {
		transform: translate(100%, 0px);
	}

	:global(.tl-container[dir='rtl']) .sidebar {
		left: auto;
		right: calc(var(--w) * -1);
	}

	:global(.tl-container[dir='rtl']) .sidebar[data-visiblemobile='true'] {
		transform: translate(-100%, 0px);
	}

	.sidebarOverlayMobile[data-visiblemobile='true'] {
		display: block;
	}
}

.sidebarContent {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	margin: 0;
	padding: 0 12px 40px 12px;
	overflow-y: scroll;
	overflow-x: visible;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}

.sidebarContent::-webkit-scrollbar {
	display: none;
}

/* -------------------- Hoverable ------------------- */

.hoverable::after {
	display: block;
	content: '';
	position: absolute;
	top: 2px;
	left: 0px;
	right: 0px;
	bottom: 2px;
	border-radius: 4px;
	background-color: var(--tl-color-muted-0);
	z-index: 0;
	pointer-events: none;
	visibility: hidden;
}

.hoverable:has(*[data-state='open'])::after,
.hoverable[data-active='true']::after {
	background-color: var(--tl-color-muted-2);
	visibility: visible;
}

@media (hover: hover) {
	.hoverable:hover::after {
		visibility: visible;
	}

	.hoverable {
		color: var(--tl-color-text-0);
	}
	.hoverable[data-active='true'],
	.hoverable:hover {
		color: var(--tl-color-text-0);
	}
}

/* ----------------- Sidebar toggle ----------------- */

.sidebarToggle {
	position: relative;
	background: none;
	border: none;
	cursor: pointer;
	width: 40px;
	height: 40px;
	color: var(--tl-color-text-0);
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: all;
	flex-shrink: 0;
	padding: 0px;
}

.sidebarToggle::after {
	display: block;
	content: '';
	position: absolute;
	top: 4px;
	left: 4px;
	right: 4px;
	bottom: 4px;
	border-radius: 4px;
	pointer-events: none;
	z-index: 0;
	visibility: hidden;
	background-color: var(--tl-color-muted-0);
}

.sidebarToggle:focus-visible {
	border-radius: 8px;
	outline-offset: -4px;
	outline: 2px solid var(--tl-color-focus);
}

@media (hover: hover) {
	.sidebarToggle:hover {
		z-index: 100;
	}

	.sidebarToggle:hover::after {
		visibility: visible;
	}
}

.sidebarToggle[data-mobile='true'] {
	display: flex;
}

.sidebarToggle[data-mobile='false'] {
	display: none;
}

@media (min-width: 768px) {
	.sidebarToggle[data-mobile='true'] {
		display: none;
	}

	.sidebarToggle[data-mobile='false'] {
		display: flex;
	}
}

/* --------------------- Top area -------------------- */

/* Figma: the logo section is 44px tall, the switcher section below it 48px
   (8px padding + 32px trigger + 8px padding), putting the first divider at
   92px. */
.sidebarTopRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex: 0 0 auto;
	height: 44px;
	padding: 3px 8px 0px 4px;
	gap: var(--tl-space-3);
}

/* Workspace link */

.sidebarWorkspaceButton {
	background: none;
	border: none;
	position: relative;
	height: 40px;
	flex-grow: 2;
	display: flex;
	align-items: center;
	padding-right: 6px;
	/* The logo is 16px tall, with its mark centered on the same vertical axis as
	   the action-row icons below. */
	padding-left: 15.3px;
	background-color: var(--tla-color-sidebar);
	overflow: hidden;
	padding-bottom: 1px;
}

.sidebarWorkspaceButton span[role='img'] {
	width: 64px;
}

/* Create file button */

.sidebarCreateFileButton {
	background: none;
	border: none;
	cursor: pointer;
	position: relative;
	top: 0px;
	right: -4px;
	height: 36px;
	width: 36px;
	/* The base .tlui-button sets min-width: 40px; override it so the width above actually applies
	   (a bare width < min-width is ignored). Box is 36px so the ::after hover pill (inset 2px) is a
	   32x32 square, with a 4px gap to the neighbouring pill. */
	min-width: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: inherit;
	flex-shrink: 0;
	padding: 0px;
	z-index: 10;
}

:global(.tl-container[dir='rtl']) .sidebarCreateFileButton {
	right: auto;
	left: -8px;
}

.sidebarCreateFileButton::after {
	display: block;
	content: '';
	position: absolute;
	top: 2px;
	left: 2px;
	right: 2px;
	bottom: 2px;
	border-radius: 4px;
	pointer-events: none;
	z-index: 0;
	visibility: hidden;
	background-color: var(--tl-color-muted-0);
}

.sidebarCreateFileButton:focus-visible {
	border-radius: 8px;
	outline-offset: -4px;
}

@media (hover: hover) {
	.sidebar:hover .sidebarCreateFileButton:hover::after {
		visibility: visible;
	}
}

/* ------------------- Bottom area ------------------ */

.sidebarBottomArea {
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	margin-top: 0px;
	padding: 0 12px;
}

/* The bottom area's own padding already provides the 12px inset, so its
   dividers sit flush. */
.sidebarBottomArea .sidebarDivider {
	margin: 0px 0px 6px 0px;
}

/* ------------------- Bottom row ------------------- */

.sidebarBottomRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex: 0 0 auto;
}

/* ----------------- Link button ---------------- */

.sidebarLinkButton {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	height: 36px;
	flex: 0 0 auto;
	background: none;
	border: none;
	cursor: pointer;
	color: var(--tl-color-text-0);
	padding: 0px 8px;
	text-align: left;
	text-decoration: none;
}

.sidebarLinkButton > span[role='img'] {
	flex-shrink: 0;
}

.sidebarLinkButtonLabel {
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sidebarLinkButton:focus-visible {
	outline-offset: -2px;
}

/* User settings menu */

.sidebarUserSettingsTrigger {
	background: none;
	border: none;
	position: relative;
	height: 36px;
	min-height: 36px;
	flex-grow: 2;
	display: flex;
	align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 0px 4px 0px 8px;
	gap: 0px;
	text-align: left;
	cursor: pointer;
}

.sidebarUserSettingsTrigger:focus-visible {
	border-radius: 10px;
	outline-offset: -5px;
}

.sidebarUserSettingsTrigger::after {
	inset: 2px 0px;
}

.sidebarUserSettingsAvatarIcon {
	flex: 0 0 auto;
	color: var(--tl-color-text-0);
	margin-inline-end: 6px;
}

.sidebarUserSettingsName {
	flex: 1 1 auto;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: var(--tl-color-text-0);
}

.sidebarUserSettingsIcon {
	width: 36px;
	height: 36px;
	min-width: 0;
	margin-inline-end: -6px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	color: var(--tl-color-text-3);
}

@media (hover: hover) {
	.sidebarUserSettingsTrigger:hover {
		color: var(--tl-color-text-0);
	}

	.sidebarUserSettingsIcon {
		color: var(--tl-color-text-3);
	}

	.sidebarUserSettingsTrigger:hover .sidebarUserSettingsIcon {
		color: var(--tl-color-text-0);
	}
}

.sidebarUserSettingsTrigger[data-state='open']::after {
	visibility: visible;
}

/* ---------------- File link section --------------- */

.sidebarFileSectionWrapper {
	margin-top: 8px;
	margin-bottom: 28px;
}

/* When a section is the only one rendered (e.g. just "Today" or just "Older"),
   its header is redundant, so hide it. */
.sidebarFileSectionWrapper:only-child .sidebarFileSectionTitle {
	display: none;
}

.sidebarFileSection {
	position: relative;
	background: var(--tla-color-sidebar);
}

.sidebarFileSectionTitle {
	position: relative;
	width: 100%;
	height: 36px;
	padding: 0px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--tl-space-2);
	color: var(--tl-color-text-3);
	font-weight: 500;
}

/* In dark mode, text-3 alone is too low-contrast on the darkest theme sidebars
   (e.g. GitHub, One Dark, Flexoki); blend toward the primary text color to lift
   the floor. Light themes keep plain text-3, where it reads fine and stays subtle. */
:global(.tla-theme__dark) .sidebarFileSectionTitle {
	color: color-mix(in srgb, var(--tl-color-text-3) 60%, var(--tl-color-text));
}

/* ----------------------------- Shared section ----------------------------- */

.sidebarSection {
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	justify-content: center;
	padding: 6px 12px;
}

/* --------------- Workspace switcher --------------- */

.sidebarWorkspaceSwitcher {
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	justify-content: center;
	padding: 0px 12px;
	height: 48px;
}

.sidebarWorkspaceSwitcherTrigger {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 36px;
	width: 100%;
	gap: 6px;
	background: none;
	border: none;
	cursor: pointer;
	color: var(--tl-color-text-0);
	padding: 0px 8px;
	text-align: left;
	min-width: 0;
}

.sidebarWorkspaceSwitcherTrigger:focus-visible {
	outline-offset: -2px;
}

.sidebarWorkspaceSwitcherTrigger[data-state='open']::after {
	background-color: var(--tl-color-muted-2);
	visibility: visible;
}

.sidebarWorkspaceSwitcherLabel {
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	position: relative;
	z-index: 1;
	font-weight: 800;
}

.sidebarWorkspaceSwitcherChevrons {
	flex-shrink: 0;
	position: relative;
	z-index: 1;
}

.sidebarWorkspaceSwitcherMenu {
	/* Width is enforced on the popper wrapper below. Use --radix-popper-anchor-width (the
	   trigger width, which Radix sets on the portaled wrapper) — NOT --tla-sidebar-width,
	   which is declared on the sidebar layout and does NOT reach this menu once it's portaled
	   out into the editor container. The trigger spans the sidebar minus its 2×12px padding,
	   so +24px brings it back to the full sidebar width (so the picker hangs ~8px over the
	   edge). The wrapper is sized below; stretch the panel to fill it (it would otherwise
	   hug the workspace names). Cap it so long names truncate rather than grow past it. */
	width: 100%;
	max-width: max(260px, calc(var(--radix-popper-anchor-width) + 24px));
	max-height: 70vh;
	overflow-y: auto;
	padding: 2px 0px;
}

/* Like the select dropdown, popper writes `min-width: max-content` inline on the wrapper, so it
   hugs its content; widen it to the trigger width here. !important is unavoidable: an inline
   style outranks every selector, so it is the only way to override it. (A DropdownMenu is always
   popper-positioned, so unlike the select there is no item-aligned alternative to weigh.) */
:global([data-radix-popper-content-wrapper]):has(> .sidebarWorkspaceSwitcherMenu) {
	min-width: max(260px, calc(var(--radix-popper-anchor-width) + 24px)) !important;
}

.sidebarWorkspaceSwitcherRoot {
	position: relative;
	z-index: var(--tl-layer-menus);
}

.sidebarWorkspaceSwitcherItem {
	position: relative;
	display: flex;
	align-items: center;
	height: 40px;
	padding: 0px 12px;
	color: var(--tl-color-text-0);
	cursor: pointer;
	outline: none;
	min-width: 0;
	z-index: 1;
}

.sidebarWorkspaceSwitcherMenu > * {
	margin-top: -4px;
	margin-bottom: -4px;
}

.sidebarWorkspaceSwitcherMenu > *:hover {
	z-index: 2;
}

.sidebarWorkspaceSwitcherMenu > *:nth-of-type(1) {
	margin-top: 0px;
}

.sidebarWorkspaceSwitcherMenu > *:nth-last-of-type(1) {
	margin-bottom: 0px;
}

.sidebarWorkspaceSwitcherItem::after {
	content: '';
	position: absolute;
	inset: 4px 6px;
	opacity: 0;
	pointer-events: none;
	border-radius: 4px;
}

.sidebarWorkspaceSwitcherItem[data-highlighted]::after {
	opacity: 1;
	background-color: var(--tl-color-muted-0);
}

.sidebarWorkspaceSwitcherItem[data-highlighted]::after {
	opacity: 1;
	background-color: var(--tl-color-muted-2);
}

.sidebarWorkspaceSwitcherItemLabel {
	flex: 0 1 auto;
	display: flex;
	width: 100%;
	align-items: center;
	gap: 6px;
	min-width: 0;
}

/* These labels are flex rows (icon + text), so the ellipsis must live on the
   text node itself — text-overflow does nothing on a flex container whose text
   is a flex item. */
.sidebarTruncatedText {
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* Override the menu's negative item margins so the separator sits flush
   between the workspace list and the "New workspace" row. */
.sidebarWorkspaceSwitcherMenu > .sidebarWorkspaceSwitcherSeparator {
	height: 1px;
	margin: 6px 0px;
	background-color: var(--tl-color-divider, rgba(232, 232, 232, 1));
}

.sidebarCreateWorkspaceButton {
	position: relative;
	display: flex;
	align-items: center;
	gap: 6px;
	height: 32px;
	min-width: 0;
	background: none;
	border: none;
	cursor: pointer;
	color: var(--tl-color-text-0);
	padding: 0px 8px;
	text-align: left;
}

.sidebarCreateWorkspaceButton > span[role='img'] {
	flex-shrink: 0;
}

.sidebarCreateWorkspaceButton:focus-visible {
	outline-offset: -2px;
}

/* 36px rows whose hover highlight is 32px tall (the .hoverable::after insets
   2px top and bottom), same as the file rows. */
.sidebarActionButton {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	height: 36px;
	flex: 0 0 auto;
	background: none;
	border: none;
	cursor: pointer;
	padding: 0px 8px;
	text-align: left;
	color: var(--tl-color-text-0);
}

.sidebarActionButton span[role='img'] {
	width: 15px;
	height: 15px;
	position: relative;
	color: var(--tl-color-text-0);
}

.sidebarActionButtonLabel {
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sidebarActionButton:focus-visible {
	outline-offset: -2px;
}

/* ------------------- Sidebar search ------------------ */

/* Sits in the same 36px row as the search action button it replaces. The focus
   ring is drawn by ::before so it matches the rename input's bordered box. */
.sidebarSearch {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	height: 36px;
	flex: 0 0 auto;
	/* Match the file rows below. */
	padding: 0px 4px 0px 8px;
	color: var(--tl-color-text-0);
}

.sidebarSearch::before {
	content: '';
	position: absolute;
	inset: 2px 0px;
	border-radius: 4px;
	border: 1px solid transparent;
	pointer-events: none;
}

.sidebarSearch:focus-within::before {
	border-color: var(--tl-color-primary);
}

/* Match the action button's 12px icon grid alignment. Sits above the hover
   highlight (.hoverable::after, z-index 0). */
.sidebarSearchIcon {
	flex-shrink: 0;
	z-index: 1;
	height: 15px;
	width: 15px;
	color: var(--tl-color-text-0);
}

.sidebarSearchInput {
	flex: 1 1 auto;
	min-width: 0;
	/* Size by the line box and let the flex row center it, the same way the
	   search action button's label is centered. Giving the input an explicit
	   36px height makes it center its text internally, which rounds ~1px lower
	   than the label and shifts the placeholder down. */
	height: auto;
	background: none;
	border: none;
	padding: 0px;
	color: var(--tl-color-text-0);
	position: relative;
	z-index: 1;
}

/* Like the file item menu trigger, but with an X icon, and pulled in only as
   far as the row's edge so the button and its focus ring stay inside the
   search box border instead of escaping it on the right. */
.sidebarSearchClear {
	padding: 0px;
	background: none;
	border: none;
	position: relative;
	outline: none;
	margin-inline-end: -6px;
	width: 36px;
	height: 36px;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	z-index: 3;
	cursor: pointer;
	color: var(--tl-color-text-0);
}

.sidebarSearchClear:after {
	content: none;
}

.sidebarSearchClear:focus-visible {
	border-radius: 8px;
	outline-offset: -4px;
}

.sidebarSearchEmpty {
	padding: var(--tl-space-3);
	color: var(--tl-color-text-3);
}

/* An 8px-tall block with the 1px line sitting in its middle, inset 12px from
   the sidebar edges. */
.sidebarDivider {
	height: 8px;
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	margin: 0 12px;
}

.sidebarDivider::after {
	content: '';
	width: 100%;
	height: 1px;
	background-color: var(--tl-color-divider);
}

/* The scroll content's own padding already provides the 12px inset, so the
   "Clear search" section keeps only the vertical rhythm. */
.sidebarContent .sidebarSection {
	padding-left: 0;
	padding-right: 0;
}

/* Halve the 28px section gap between the last file section and "Clear search";
   the full inter-section gap reads as too detached for a related control. */
.sidebarContent .sidebarFileSectionWrapper + .sidebarSection {
	margin-top: -14px;
}

.sidebarFileSectionTitlePadding span[role='img'] {
	margin-bottom: 1px;
}

/* ------------------- File links ------------------- */

.sidebarFileListItem {
	background-color: transparent;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 36px;
	padding: 0px 4px 0px 8px;
}

/* Chrome hack: promote the pressed row to its own compositing layer so the
   native drag image keeps a transparent background. :active fires on
   mousedown, before dragstart takes the snapshot, so the layer exists in
   time. translateZ(0) promotes without touching opacity, so there's no
   color shift at all. */
.sidebarFileListItem:active {
	transform: translateZ(0);
}

.sidebarFileListItem[data-active='true'][data-enhanced-a11y-mode='true'] {
	border-radius: 4px;
	outline: 2px solid var(--tl-color-text-0);
	outline-offset: -2px;
}

.sidebarFileListItemContent {
	flex: 1 1 auto;
	min-width: 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: var(--tl-space-3);
	position: relative;
	pointer-events: none;
	z-index: 2;
}

.sidebarFileListItemLabel {
	flex: 0 1 auto;
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	position: relative;
	z-index: 1;
	color: var(--tl-color-text-0);
}

/* The selected file reads as the current one with a heavier weight. */
.sidebarFileListItem[data-active='true'] .sidebarFileListItemLabel {
	font-weight: 600;
}

/* The portion of a file name that matches the active search query. */
.sidebarFileListItemLabelMatch {
	font-weight: 700;
	color: var(--tl-color-text-0);
}

.sidebarFileListItemRenameInputWrapper {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0px 8px 0px calc(8px + var(--tla-sidebar-group-item-padding-left, 0px));
	outline-offset: -2px;
	gap: var(--tl-space-3);
	position: relative;
}

.sidebarFileListItemRenameInputWrapper::before {
	content: '';
	position: absolute;
	bottom: 0px;
	inset: 2px 0px;
	border-radius: 4px;
	border: 1px solid var(--tl-color-primary);
}

.sidebarFileListItemRenameInputWrapper div:global(.tlui-input__wrapper) {
	height: 36px;
}

.sidebarFileListItemRenameInput {
	/* Size by the line box and let the 36px wrapper center it, the same way the
	   file label is centered in its row. Giving the input an explicit 36px
	   height makes it center its text internally, which rounds ~1px lower than
	   the label and shifts the name down when entering rename mode. */
	height: auto;
	flex: 1 1 auto;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	position: relative;
	z-index: 1;
}

/* Match the selected file's heavier label weight while renaming it. */
.sidebarFileListItemRenameInputActive {
	font-weight: 600;
}

.sidebarFileListItemButton {
	padding: 0px;
	background: none;
	border: none;
	position: absolute;
	top: 0px;
	left: 3px;
	/* 36px + 6px	 is the menu button width + padding */
	width: calc(100% - 42px);
	height: 100%;
	cursor: pointer;
	z-index: 2;
	pointer-events: all;
}

.sidebarFileListItemButton:focus-visible {
	border-radius: 4px;
	outline-offset: 0px;
}

.sidebarFileListItemMenuTrigger {
	padding: 0px;
	background: none;
	border: none;
	position: relative;
	outline: none;
	margin-inline-end: -6px;
	width: 36px;
	height: 36px;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--tl-color-text-3);
	flex: 0 0 auto;
	z-index: 3;
	cursor: pointer;
}

.sidebarFileListItemMenuTrigger:after {
	content: none;
}

.sidebarFileListItemMenuTrigger:focus-visible {
	border-radius: 8px;
	outline-offset: -4px;
}

@media (hover: hover) {
	.sidebarFileListItemMenuTrigger {
		display: none;
	}
	/*
		For guest files we show a guest icon at the end of the filename
		but we don't want it to jump out of the way when the user hovers
	*/
	.sidebarFileListItem[data-is-own-file='false'] .sidebarFileListItemMenuTrigger {
		visibility: hidden;
		display: flex;
	}
	:global(.tla:has(.tl-container__focused:not(.tl-container__no-focus-ring)))
		.sidebarFileListItemMenuTrigger {
		visibility: visible;
		display: flex;
	}

	.sidebarFileListItem .sidebarFileListItemMenuTrigger[data-state='open'],
	.sidebarFileListItem:hover .sidebarFileListItemMenuTrigger {
		visibility: visible;
		display: flex;
	}

	.sidebarFileListItemMenuTrigger:hover {
		color: var(--tl-color-text-0);
	}
}

/* Guest badge */

.sidebarFileListItemGuestBadge {
	display: inline-flex;
	pointer-events: none;
	flex: 0 0 auto;
}

.sidebarFileListItemGuestBadgeTrigger {
	margin-left: 4px;
	border-radius: 50%;
	overflow: hidden;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	outline: none;
	border: none;
	width: 14px;
	height: 14px;
	z-index: 3;
	padding: 0;
	background: none;
	pointer-events: all;
	cursor: pointer;
	color: var(--tl-color-text-0);
}

.sidebarFileSectionTitleText {
	flex: 1 1 auto;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
